import { render, staticRenderFns } from "./GjwSwitch.vue?vue&type=template&id=6d826e53&scoped=true&"
import script from "./GjwSwitch.vue?vue&type=script&lang=js&"
export * from "./GjwSwitch.vue?vue&type=script&lang=js&"
import style0 from "./GjwSwitch.vue?vue&type=style&index=0&id=6d826e53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d826e53",
  null
  
)

export default component.exports